<template>
  <b-card :header="caption">
    <b-form id="location-form">
      <b-form-group>
        <b-input-group>
          <b-input-group-prepend>
            <b-input-group-text>Name</b-input-group-text>
          </b-input-group-prepend>
          <b-form-input type="text" v-model="formData.name" placeholder="name"></b-form-input>
        </b-input-group>
      </b-form-group>

      <b-form-group>
        <b-input-group>
          <b-input-group-prepend>
            <b-input-group-text>Description</b-input-group-text>
          </b-input-group-prepend>
          <b-form-textarea
            :rows="3"
            :max-rows="6"
            id="description"
            v-model="formData.description"
            placeholder="Description"
          ></b-form-textarea>
        </b-input-group>
      </b-form-group>

      <div class="form-group form-actions">
        <b-button @click="submitDataLocation" type="submit" size="sm" variant="primary">Save</b-button>
      </div>
    </b-form>

    <b-modal v-model="modalShowBothEmpty" ok-only ok-variant="secondary" ok-title="Ok">
      Name of location should not be empty. Please fill name for new location.
      <div slot="modal-footer" class="w-100">
        <b-btn
          size="sm"
          class="float-right"
          variant="primary"
          @click="modalShowBothEmpty = !modalShowBothEmpty"
        >Ok</b-btn>
      </div>
    </b-modal>
  </b-card>
</template>

<script>
let qs = require('qs')
const constants = require('./shared/constants')
const BASE = constants.NEWPORT_CONST.API_URL
const API = BASE + '/api/locations/add'
const API_LIST = BASE + '/api/locations/simpleList'

function postdata (url, data) {
  return fetch(url, {
    body: qs.stringify(data),
    headers: {
      'content-type': 'application/x-www-form-urlencoded'
    },
    method: 'POST'
  }).then(res => res.json())
}

async function getLocationList () {
  let parameters = {
    client_id: constants.NEWPORT_CONST.CLIENT_ID,
    client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
    accessToken: localStorage.getItem('token')
  }
  let res = await postdata(API_LIST, parameters)
  return res.locations
}

export default {
  name: 'location-add-form',
  data () {
    return {
      modalShowBothEmpty: false,
      locations: [],
      formData: {
        client_id: constants.NEWPORT_CONST.CLIENT_ID,
        client_secret: constants.NEWPORT_CONST.CLIENT_SECRET,
        accessToken: localStorage.getItem('token'),
        name: '',
        description: ''
      }
    }
  },
  props: {
    caption: {
      type: String,
      default: 'Add New Location'
    }
  },
  methods: {
    submitDataLocation (evt) {
      evt.preventDefault()
      if (this.formData.name === '') {
        this.modalShowBothEmpty = true
      } else {
        if (this.formData.description === '') {
          this.formData.description = '-'
        }
        postdata(API, this.formData)
          .then(data => {
            // let local = localStorage.getItem('localLocationsList')
            // if (local !== null || local !== 'undefined') {
              // local = JSON.parse(local)
          this.$root.$emit('addLocation', data.location)
          this.formData.name = ''
          this.formData.description = ''
            // }

          })
          .catch(error => {
            console.error(error)
          })
      }
    },
    validateBeforeSubmit () {
      this.$validator.validateAll().then(result => {
        if (result) {
          alert('From Submitted!')
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/base/LocationAddForm.vue